/* eslint-disable react/prop-types */
export default function MenuFormDisplaySection({ step, title, hint, children }) {
  return (
    <section className="menu-form-display-section">
      <div className="menu-form-display-section__head">
        {step ? (
          <span className="menu-form-display-section__step" aria-hidden="true">
            {step}
          </span>
        ) : null}
        <div className="menu-form-display-section__head-text">
          <h3 className="menu-form-display-section__title">{title}</h3>
          {hint ? <p className="menu-form-display-section__hint">{hint}</p> : null}
        </div>
      </div>
      <div className="menu-form-display-section__body">{children}</div>
    </section>
  );
}
